import { useState } from "react";
import { SearchCodeType } from "@/shared/config/globals";
import { Institution } from "@/features/institutions/contexts/institutions-context";


export const useInstitutionsStates = () => {
  // 現在選択されている検索頭文字（全件検索は空文字指定）
  const [currentSearchCode, setCurrentSearchCode] = useState<SearchCodeType>();
  // 表示する金融機関一覧（表示条件絞り後）
  const [showInstitutions, setShowInstitutions] = useState<Institution[]>([]);

  return {
    currentSearchCode,
    setCurrentSearchCode,
    showInstitutions,
    setShowInstitutions,
  };
};
